
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.55 3.539L6.242 5.947a.583.583 0 01-.485 0L.45 3.539c-.377-.171-.377-.741 0-.912L5.757.219a.584.584 0 01.485 0l5.308 2.408c.377.17.377.74 0 .912zM.45 5.551l1.323-.6 3.683 1.67a1.307 1.307 0 001.087 0l3.683-1.67 1.324.6c.377.17.377.74 0 .911L6.242 8.868a.585.585 0 01-.485 0L.45 6.462c-.377-.17-.377-.74 0-.911zm0 2.912l1.318-.598 3.688 1.672a1.307 1.307 0 001.087 0l3.688-1.672 1.32.598c.376.17.376.74 0 .911L6.241 11.78a.585.585 0 01-.485 0L.45 9.374c-.377-.17-.377-.74 0-.911z","fill":"#525F7F"}})])
          )
        }
      }
    